/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsGraphDto } from '../../models/submissions-graph-dto';

export interface FactorDocumentPerDayGet$Params {
  fromDate?: string;
  toDate?: string;
  clientNames?: Array<string>;
  topClients?: number;
}

export function factorDocumentPerDayGet(http: HttpClient, rootUrl: string, params?: FactorDocumentPerDayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
  const rb = new RequestBuilder(rootUrl, factorDocumentPerDayGet.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.query('clientNames', params.clientNames, {});
    rb.query('topClients', params.topClients, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsGraphDto>>;
    })
  );
}

factorDocumentPerDayGet.PATH = '/Factor/document-per-day';
